import app from 'flarum/forum/app';

// Nothing left to register on the forum side.
//
// Chirp, Forage and Swoop were retired on 2026-09-21 and Custom Sites was
// dropped on 2026-09-27 (Karl: "In dashboard, I still see Custom sites,
// remove it") — the last dashboard tab this extension owned. Their leftover
// components, models and copy were deleted on 2026-10-06.
//
// Removing a route is not enough on its own: app.route() throws on an unknown
// name, so every caller has to go in the same change or the page that calls it
// breaks. Nothing outside this file linked to lr.sites.
app.initializers.add('linkrobins-lr-services', () => {});